(function () {
  "use strict";
  if (window.__klaviyoAtcHooked) return;
  window.__klaviyoAtcHooked = true;
  window._learnq = window._learnq || [];

  function euro(c) { return (typeof c === "number" ? c / 100 : 0); }

  function pushEvent(payload) {
    try {
      fetch("/cart.js", { credentials: "same-origin" })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          try {
            var item = (payload && payload.items && payload.items[0]) || payload || {};
            var origin = window.location.origin;
            window._learnq.push(["track", "Added to Cart", {
              $value: euro(cart.total_price),
              AddedItemProductName: item.product_title || item.title || "",
              AddedItemProductID: item.product_id || "",
              AddedItemVariantID: item.variant_id || item.id || "",
              AddedItemSKU: item.sku || "",
              AddedItemPrice: euro(item.price),
              AddedItemQuantity: item.quantity || 1,
              AddedItemImageURL: item.image || "",
              AddedItemURL: item.url ? origin + item.url : origin,
              ItemNames: (cart.items || []).map(function (i) { return i.product_title; }),
              CheckoutURL: origin + "/checkout",
              Items: (cart.items || []).map(function (i) {
                return {
                  ProductID: i.product_id,
                  SKU: i.sku,
                  ProductName: i.product_title,
                  Quantity: i.quantity,
                  ItemPrice: euro(i.price),
                  RowTotal: euro(i.line_price),
                  ProductURL: origin + i.url,
                  ImageURL: i.image
                };
              })
            }]);
          } catch (e) {}
        })
        .catch(function () {});
    } catch (e) {}
  }

  if (typeof window.fetch === "function") {
    var origFetch = window.fetch;
    window.fetch = function () {
      var promise = origFetch.apply(this, arguments);
      try {
        var a0 = arguments[0];
        var url = typeof a0 === "string" ? a0 : (a0 && a0.url) || "";
        if (url && url.indexOf("/cart/add") !== -1) {
          promise.then(function (res) {
            try {
              if (res && res.ok && typeof res.clone === "function") {
                res.clone().json().then(pushEvent).catch(function () {});
              }
            } catch (e) {}
          }).catch(function () {});
        }
      } catch (e) {}
      return promise;
    };
  }

  try {
    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      try { this.__kl_url = url; } catch (e) {}
      return origOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      try {
        var self = this;
        if (self.__kl_url && String(self.__kl_url).indexOf("/cart/add") !== -1) {
          self.addEventListener("load", function () {
            try { pushEvent(JSON.parse(self.responseText)); } catch (e) {}
          });
        }
      } catch (e) {}
      return origSend.apply(this, arguments);
    };
  } catch (e) {}
})();